import { itemDef, RAFT_PART_DEFS, RAFT_PARTS, stageCost, type Difficulty, type RaftPartId } from "@eldrun/content";

export interface RaftPartLike {
  stage: number;
  done: boolean;
  have: { get(item: string): number | undefined };
}

export interface RaftNeed {
  item: string;
  name: string;
  have: number;
  need: number;
  /** Quanto o jogador tem no inventário. */
  owned: number;
}

export interface RaftRow {
  part: RaftPartId;
  name: string;
  /** Etapa atual (1…n) e quantas há. */
  stage: number;
  stages: number;
  done: boolean;
  needs: RaftNeed[];
  /** Tem algo do que falta (o Altar nunca: vem do Relicário). */
  canDeposit: boolean;
}

const itemName = (id: string): string => (id === "muiraquita" ? "Gemas (Relicário)" : (itemDef(id)?.name ?? id));

/** Linhas do painel de reparo: cada componente com a etapa, o que falta e se dá para depositar. */
export function raftRows(parts: { get(id: string): RaftPartLike | undefined }, players: number, difficulty: Difficulty, owned: (item: string) => number): RaftRow[] {
  return RAFT_PARTS.map((id) => {
    const def = RAFT_PART_DEFS[id];
    const p = parts.get(id);
    const stage = p?.stage ?? 0;
    const done = p?.done ?? false;
    const cost = done ? {} : stageCost(id, stage, players, difficulty);
    const needs = Object.entries(cost).map(([item, need]) => ({ item, name: itemName(item), have: p?.have.get(item) ?? 0, need, owned: owned(item) }));
    return {
      part: id,
      name: def.name,
      stage: Math.min(stage + 1, def.stages.length),
      stages: def.stages.length,
      done,
      needs,
      canDeposit: id !== "altar" && !done && needs.some((n) => n.have < n.need && n.owned > 0),
    };
  });
}

/** Linha de estado da Jangada no HUD (contagem e travessia). */
export function raftStatus(stage: string, countdown: number): string | undefined {
  if (stage === "contagem") return `Zarpando em ${countdown} s · todos no convés`;
  if (stage === "travessia") return "Travessia: a ilha some na névoa…";
  return undefined;
}
